import * as React from 'react'
import { Text, Colors, Spacing, StackChildren } from '@doordash/design-language'
import Separator from '@doordash/component-separator'
import t from './strings'

export const OfferLetter: React.FC<{}> = () => (
  <React.Fragment>
    <Separator
      verticalMargin={Spacing.Small}
      type={Separator.Types.FullBorder}
    />
    <StackChildren size={StackChildren.Sizes.Small}>
      <Text styles={Text.Styles.Bold16}>{t.CAofferTitle()}</Text>
      <Text styles={Text.Styles.CalloutLabel} weight={Text.Weights.Medium}>
        {t.CAofferLink()}
      </Text>
      <Text color={Colors.TextSecondary} styles={Text.Styles.Medium14}>
        {t.CAofferLegal()}
      </Text>
    </StackChildren>
  </React.Fragment>
)

export default OfferLetter
